import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=99a166ac&scoped=true"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"
import style0 from "./Kanban.vue?vue&type=style&index=0&id=99a166ac&prod&lang=css"
import style1 from "./Kanban.vue?vue&type=style&index=1&id=99a166ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a166ac",
  null
  
)

export default component.exports